"use client";
import { Stack } from "@chakra-ui/react";
import { scrollToElement } from "@/utils/scrollToElement";
import { Button } from "@/elements";
import WhyOneMindFrame from "@/components/whyOneMind";
import { WHY_ONEMIND_CONSTANTS } from "./constants";

const UseCases = () => {
  return (
    <Stack gap={6} align={"center"}>
      <WhyOneMindFrame {...WHY_ONEMIND_CONSTANTS} />
      <Button
        variant={"ideal"}
        alignSelf={"center "}
        onClick={() => scrollToElement("contact-us", 120)}
      >
        Ready To Try?
      </Button>
    </Stack>
  );
};

export default UseCases;
